export default __webpack_public_path__ + "static/media/Snd_C9.d557da81.mp3";